// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1E18M","requiredAsterisk":"Info_requiredAsterisk__VPEAa"};